import { Outlet, Link, useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

const menu = [
  { path: "/", icon: "📊", label: "Dashboard" },
  { path: "/productos", icon: "📦", label: "Productos" },
  { path: "/categorias", icon: "🏷️", label: "Categorias" },
  { path: "/pedidos", icon: "🛒", label: "Pedidos" },
  { path: "/clientes", icon: "👥", label: "Clientes" },
  { path: "/facturacion", icon: "🧾", label: "Facturación" },
  { path: "/creditos", icon: "💳", label: "Créditos" },
  { path: "/vendedores", icon: "🧑‍💼", label: "Vendedores" },
  { path: "/gastos", icon: "💸", label: "Gastos" },
  { path: "/reportes", icon: "📈", label: "Reportes" },
  { path: "/auditoria", icon: "🕵️", label: "Auditoría" },
  { path: "/descargar-app", icon: "📲", label: "Descargar App" },
  { path: "/resenas", icon: "⭐", label: "Resenas" },
  { path: "/banners", icon: "📢", label: "Banners" },
  { path: "/emojis", icon: "😀", label: "Iconos" },
];

export default function Layout() {
  const location = useLocation();
  const navigate = useNavigate();
  const [disco, setDisco] = useState<any>(null);
  const [sidebarAbierto, setSidebarAbierto] = useState(false);

  useEffect(() => {
    fetch("/api/sistema/disco").then(r => r.json()).then(setDisco).catch(() => {});
  }, []);

  useEffect(() => {
    setSidebarAbierto(false);
  }, [location.pathname]);

  const cerrarSesion = () => { localStorage.removeItem("token"); navigate("/login"); };

  const Sidebar = () => (
    <aside style={{width:"240px",background:"#0D47A1",display:"flex",flexDirection:"column",height:"100%"}}>
      <div style={{padding:"24px",borderBottom:"1px solid rgba(255,255,255,0.1)"}}>
        <div style={{fontFamily:"Montserrat,sans-serif",fontWeight:900,fontSize:"18px",color:"#fff"}}>
          IMPORTACIONES <span style={{color:"#90CAF9"}}>B&Y</span>
        </div>
        <div style={{color:"rgba(255,255,255,0.4)",fontSize:"11px",marginTop:"4px"}}>Panel Admin</div>
      </div>
      <nav style={{flex:1,padding:"16px",display:"flex",flexDirection:"column",gap:"4px",overflowY:"auto",minHeight:0}}>
        {menu.map(item => (
          <Link key={item.path} to={item.path}
            style={{display:"flex",alignItems:"center",gap:"12px",padding:"12px 16px",borderRadius:"12px",textDecoration:"none",fontSize:"14px",fontWeight:600,
              background:location.pathname===item.path?"rgba(255,255,255,0.15)":"transparent",
              color:location.pathname===item.path?"#fff":"rgba(255,255,255,0.6)"}}>
            <span>{item.icon}</span>{item.label}
          </Link>
        ))}
      </nav>
      {disco && (
        <div style={{padding:"16px",borderTop:"1px solid rgba(255,255,255,0.1)",flexShrink:0}}>
          <div style={{display:"flex",justifyContent:"space-between",marginBottom:"6px"}}>
            <span style={{color:"rgba(255,255,255,0.4)",fontSize:"11px"}}>Disco</span>
            <span style={{color:"rgba(255,255,255,0.6)",fontSize:"11px",fontWeight:700}}>{disco.usado_gb}GB / {disco.total_gb}GB</span>
          </div>
          <div style={{background:"rgba(255,255,255,0.1)",borderRadius:"8px",height:"8px",overflow:"hidden"}}>
            <div style={{height:"8px",borderRadius:"8px",width:`${disco.porcentaje}%`,
              background:disco.porcentaje<50?"linear-gradient(90deg,#22c55e,#86efac)":disco.porcentaje<75?"linear-gradient(90deg,#eab308,#fde047)":"linear-gradient(90deg,#ef4444,#f97316)",
              boxShadow:disco.porcentaje<50?"0 0 8px #22c55e":disco.porcentaje<75?"0 0 8px #eab308":"0 0 8px #ef4444"}}/>
          </div>
        </div>
      )}
      <div style={{padding:"16px",borderTop:"1px solid rgba(255,255,255,0.1)",flexShrink:0}}>
        <button onClick={cerrarSesion}
          style={{width:"100%",background:"none",border:"none",color:"rgba(255,255,255,0.6)",fontSize:"14px",fontWeight:600,cursor:"pointer",display:"flex",alignItems:"center",gap:"12px",padding:"12px 16px",borderRadius:"12px",fontFamily:"Nunito,sans-serif"}}>
          🚪 Cerrar sesion
        </button>
      </div>
    </aside>
  );

  return (
    <div style={{display:"flex",height:"100vh",background:"#f3f4f6",fontFamily:"Nunito,sans-serif"}}>
      <style>{`
        @media (max-width: 768px) {
          .admin-sidebar-desktop { display: none !important; }
          .admin-sidebar-mobile { display: flex !important; }
        }
        @media (min-width: 769px) {
          .admin-sidebar-desktop { display: flex !important; }
          .admin-sidebar-mobile { display: none !important; }
          .admin-sidebar-overlay { display: none !important; }
        }
      `}</style>

      <div className="admin-sidebar-desktop" style={{flexDirection:"column",flexShrink:0}}>
        <Sidebar />
      </div>

      {sidebarAbierto && (
        <div className="admin-sidebar-overlay" onClick={() => setSidebarAbierto(false)}
          style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.5)",zIndex:200}}/>
      )}
      <div className="admin-sidebar-mobile" style={{display:"none",position:"fixed",top:0,left:0,bottom:0,zIndex:201,transform:sidebarAbierto?"translateX(0)":"translateX(-100%)",transition:"transform .3s ease",width:"240px",flexDirection:"column"}}>
        <Sidebar />
      </div>

      <main style={{flex:1,overflow:"auto",display:"flex",flexDirection:"column",minWidth:0}}>
        <header style={{background:"#fff",borderBottom:"1px solid #e5e7eb",padding:"16px 20px",display:"flex",justifyContent:"space-between",alignItems:"center",flexShrink:0}}>
          <div style={{display:"flex",alignItems:"center",gap:"12px"}}>
            <button className="admin-sidebar-mobile" onClick={() => setSidebarAbierto(!sidebarAbierto)}
              style={{display:"none",background:"#0D47A1",border:"none",color:"#fff",width:"38px",height:"38px",borderRadius:"10px",cursor:"pointer",fontSize:"18px",alignItems:"center",justifyContent:"center"}}>
              ☰
            </button>
            <div style={{fontSize:"14px",color:"#6b7280"}}>Bienvenido, <strong style={{color:"#0D47A1"}}>{localStorage.getItem("nombre")||"Admin"}</strong></div>
          </div>
          <div style={{fontSize:"12px",color:"#9ca3af",display:"none"}} className="admin-sidebar-desktop">Importaciones B&Y — Panel Admin</div>
        </header>
        <div style={{padding:"20px",flex:1,overflowY:"auto"}}><Outlet /></div>
      </main>
    </div>
  );
}
